import React, { Component, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import HomeLayout from './layouts/HomeLayout';
import InnerPageLayout from './layouts/InnerPageLayout';
import DashboardLayout from './layouts/DashboardLayout';
import AdminLayout from './layouts/AdminLayout';
import CvLayout from './layouts/RegistrationCvLayout';


import HomeComponent from './container/home/HomeComponent';
import AboutUsComponent from './container/about-us/AboutUsComponent';
// import LoginComponent from './container/auth/login/LoginComponent';
import ForgotComponent from './container/auth/forgot-password/ForgotPasswordComponent';
import FindJobComponent from './container/find-jobs/FindJobComponent';
import JobDetailsComponent from './container/job-details/JobDetailsComponent';
import PostJobComponent from './container/post-job/PostJobComponent';
import CommonRegistrationComponent from './container/auth/registration/common-reg/CommonRegistrationComponent';

import DashboardHomeComponent from './container/dashboard/home/DashboardHomeComponent';
import ApplyedJobeComponent from './container/dashboard/applyed-job/ApplyedJobComponent';
import WishListComponent from './container/dashboard/wishlist/WishLIstComponent';

import PendingJobComponents from './container/dashboard/pending-job/PendingJobComponent';

import AcceptedJobComponent from './container/dashboard/accepted-job/AcceptedJobComponent';

import MainAuthComponent from './container/main-auth/MainAuthComponent';

import AdminDashboardComponent from './container/admin-app/admin-dashboard/AdminDashboardComponent';
import ApplicantDashboardComponent from './container/admin-app/applicants-dashboard/ApplicantsDashboardComponent';
import CandidatesDashboardComponent from './container/admin-app/candidates-dashboard/CandidatesDashboardComponent';
import CustomerDashboardComponent from './container/admin-app/customer-dashboard/CustomerDashboardComponent';
import InterviewDashboardComponent from './container/admin-app/interview-dashboard/InterviewDashboardComponent';
import AdminSummaryComponent from './container/admin-app/admin-summary/AdminSummaryComponent';

import CvPageComponent from './container/cv-page/CvPageComponent';
import CvRegistrationLayout from './container/cv-page/CvRegistrationLayout';
import CvSummaryComponent from './container/Under-Construction/cv-summary/CvSummaryComponent';
import CvCompleteComponent from './container/Under-Construction/cv-complete/CvCompleteComponent';
import ScheduleInterviewComponent from './container/calendar/schedule-interview/ScheduleInterviewComponent';
import PrivateJobComponent from './container/admin-app/private-job-dashboard/PrivateJobComponent';
import CouncilJobComponent from './container/admin-app/council-job-dashboard/CouncilJobComponent';


import PostedJobComponent from './container/dashboard/posted-job/PostedJobComponent';

import ClientFormComponent from './container/client-app/client-form/ClientFormComponent';
import ClientSummaryComponent from './container/client-app/client-summary/ClientSummaryComponent';
import ClientCompleteComponent from './container/client-app/client-complete/ClientCompleteComponent';
import ClientFormLayout from './container/client-app/client-form/ClientFormLayout';
import ResistrationSelectionComponent from './container/auth/registration-selection/RegistrationSelectionComponent';
import ClientSelectionComponent from './container/client-app/client-selection/ClientSelectionComponent';

class App extends Component {
  render() {
    return (
      <Suspense fallback={'Loading Page....'}>
          {/* <Routes>
            {localStorage.getItem('token') ? (
              localStorage.getItem('is_candidate') ? (
                <Route path="/dashboard" />
              ) : localStorage.getItem('is_admin') ? (
                <Route path="/admin/dashboard" />
              ) : localStorage.getItem('schedule-interview') ? (
                <Route path="/schedule-interview" />
              ) : (
                <Route path="/registrations/form4" />
              )
            ) : (
              <Route path="/countdown" />
            )} */}
            {/* <Route path="/countdown"> */}
            <HomeLayout>

            <Routes>
              <Route path="/countdown" element={<MainAuthComponent />} />
            </Routes>
            {/* </Route> */}
            {/* <Route path="/home"> */}
                <Routes>
                  <Route path="/home" element={<HomeComponent />} />
                </Routes>
            {/* </Route> */}

            {/* <Route path="/dashboard/:path?"> */}
              <DashboardLayout>
                <Routes>
                  <Route
                    path="/dashboard"
                    element={<DashboardHomeComponent />}
                  />
                  <Route
                    path="/dashboard/applied-job"
                    element={<ApplyedJobeComponent />}
                  />
                  <Route
                    path="/dashboard/accepted-job"
                    element={<AcceptedJobComponent />}
                  />
                  <Route
                    path="/dashboard/wish-list"
                    element={<WishListComponent />}
                  />
                  <Route
                    path="/dashboard/posted-job"
                    element={<PostedJobComponent />}
                  />
                  <Route
                    path="/dashboard/pending-job"
                    element={<PendingJobComponents />}
                  />
                  {/* <Route path='/dashboard/form4' element={NFormFourComponent} /> */}
                </Routes>
              </DashboardLayout>
            {/* </Route> */}

            {/* <Route path="/admin/:path?"> */}
              <AdminLayout>
                <Routes>
                  <Route
                    path="/admin/interview-dashboard"
                    element={<InterviewDashboardComponent />}
                  />
                  <Route
                    path="/admin/dashboard"
                    element={<AdminDashboardComponent />}
                  />
                  <Route
                    path="/admin/applicants-dashboard"
                    element={<ApplicantDashboardComponent />}
                  />
                  <Route
                    path="/admin/candidates-dashboard"
                    element={<CandidatesDashboardComponent />}
                  />
                  <Route
                    path="/admin/customer-dashboard"
                    element={<CustomerDashboardComponent />}
                  />
                  <Route
                    path="/admin/private-job"
                    element={<PrivateJobComponent />}
                  />
                  <Route
                    path="/admin/council-job"
                    element={<CouncilJobComponent />}
                  />
                  {/* <Route path='/dashboard/form4' element={NFormFourComponent} /> */}
                </Routes>
              </AdminLayout>
            {/* </Route> */}
            {/* <Route path="/client/:path?"> */}
              <CvLayout>
                <ClientFormLayout>
                  <Routes>
                    <Route
                      path="/client/form1"
                      element={<ClientFormComponent />}
                    />
                    <Route
                      path="/client/summary"
                      element={<ClientSummaryComponent />}
                    />
                    <Route
                      path="/client/complete"
                      element={<ClientCompleteComponent />}
                    />
                  </Routes>
                </ClientFormLayout>
              </CvLayout>
            {/* </Route> */}
            {/* <Route path="/admins/:path?"> */}
              {/* <CvLayout>
                <CvRegistrationLayout> */}
                  <Routes>
                    <Route
                      path="/admins/summary"
                      element={<AdminSummaryComponent />}
                    />
                  </Routes>
                {/* </CvRegistrationLayout>
              </CvLayout> */}
            {/* </Route> */}
            {/* <Route path="/registration/:path?"> */}
              <CvLayout>
                <CvRegistrationLayout>
                  <Routes>
                    <Route
                      path="/registration/cv-summary"
                      element={<CvSummaryComponent />}
                    />
                    <Route
                      path="/registration/submit-cv"
                      element={<CvPageComponent />}
                    />
                    <Route
                      path="/registration/cv-complete"
                      element={<CvCompleteComponent />}
                    />
                  </Routes>
                </CvRegistrationLayout>
              </CvLayout>
            {/* </Route> */}

            {/* <Route> */}
              <InnerPageLayout>
                <Routes>
                  {/* <Route path="/login" element={<LoginComponent/>} /> */}
                  <Route
                    path="/clients/type-selection"
                    element={<ClientSelectionComponent />}
                  />
                  <Route
                    path="/user/registration-selection"
                    element={<ResistrationSelectionComponent />}
                  />
                  <Route
                    path="/forgot-password-email"
                    element={<ForgotComponent />}
                  />
                  {/* <Route path="/reset-password" element={<ResetComponent/>} /> */}
                  {/* <Route path="/pages/:id" element={<CmsComponent/>} /> */}
                  <Route path="/about-us" element={<AboutUsComponent />} />
                  <Route path="/find-jobs" element={<FindJobComponent />} />
                  <Route
                    path="/schedule-interview"
                    element={<ScheduleInterviewComponent />}
                  />
                  <Route
                    path="/job-details/:id"
                    element={<JobDetailsComponent />}
                  />
                  <Route path="/job-post" element={<PostJobComponent />} />
                  <Route
                    path="/user/registration"
                    element={<CommonRegistrationComponent />}
                  />
                  {/* <Route path="/registrations/individual/:path?">
          <IRegistrationLayout>
            <Routes>
              <Route
                path="/registrations/individual/form1"
                element={<IFormOneComponent/>}
              />
              <Route
                path="/registrations/individual/form2"
                element={<IFormTwoComponent/>}
              />
              <Route
                path="/registrations/individual/form3"
                element={<IFormThreeComponent/>}
              />
            </Routes>
          </IRegistrationLayout>
        </Route> */}
                  {/* <Route path="/registrations/council/:path?">
          <CRegistrationLayout>
            <Routes>
              <Route
                path="/registrations/council/form1"
                element={<CFormOneComponent/>}
              />
              <Route
                path="/registrations/council/form2"
                element={<CFormTwoComponent/>}
              />
              <Route
                path="/registrations/council/form3"
                element={<CFormThreeComponent/>}
              />
            </Routes>
          </CRegistrationLayout>
        </Route> */}
                  {/* //#NFormFourComponent is not used (payment form) */}
                  {/* <Route path="/registrations/:path?"> */}
                    {/* <NRegistrationLayout> */}
                      {/* <Routes>
                        <Route
                          path="/registrations/form1"
                          element={<NFormOneComponent />}
                        />
                        <Route
                          path="/registrations/form2"
                          element={<NFormTwoComponent />}
                        />
                        <Route
                          path="/registrations/form3"
                          element={<NFormThreeComponent />}
                        />
                        <Route
                          path="/registrations/form4"
                          element={<AllSummaryComponent />}
                        />
                        <Route
                          path="/registrations/form5"
                          element={<NFormFourComponent />}
                        />
                      </Routes> */}
                    {/* </NRegistrationLayout> */}
                  {/* </Route> */}
                </Routes>
              </InnerPageLayout>
              </HomeLayout>
            {/* </Route> */}
          {/* </Routes> */}
          </Suspense>
    );
  }
}

export default App;

// <Suspense fallback={'Loading Page....'}>
// <Router>
//   <Routes>
//     {localStorage.getItem('token') ? (
//       localStorage.getItem('is_candidate') ? (
//         <Route path="/dashboard" />
//       ) : localStorage.getItem('is_admin') ? (
//         <Route path="/admin/dashboard" />
//       ) : localStorage.getItem('schedule-interview') ? (
//         <Route path="/schedule-interview" />
//       ) : (
//         <Route path="/registrations/form4" />
//       )
//     ) : (
//       <Route path="/countdown" />
//     )}
//     {/* <Route path="/countdown"> */}
//       <Routes>
//         <Route path="/countdown" element={<MainAuthComponent/>} />
//       </Routes>
//     {/* </Route> */}
//     <Route path="/home">
//       <HomeLayout>
//         <Routes>
//           <Route path="/home" element={<HomeComponent/>} />
//         </Routes>
//       </HomeLayout>
//     </Route>

//     <Route path="/dashboard/:path?">
//       <DashboardLayout>
//         <Routes>
//           <Route path="/dashboard" element={<DashboardHomeComponent/>} />
//           <Route
//             path="/dashboard/applied-job"
//             element={<ApplyedJobeComponent/>}
//           />
//           <Route
//             path="/dashboard/accepted-job"
//             element={<AcceptedJobComponent/>}
//           />
//           <Route
//             path="/dashboard/wish-list"
//             element={<WishListComponent/>}
//           />
//           <Route
//             path="/dashboard/posted-job"
//             element={<PostedJobComponent/>}
//           />
//           <Route
//             path="/dashboard/pending-job"
//             element={<PendingJobComponents/>}
//           />
//           {/* <Route path='/dashboard/form4' element={NFormFourComponent} /> */}
//         </Routes>
//       </DashboardLayout>
//     </Route>

//     <Route path="/admin/:path?">
//       <AdminLayout>
//         <Routes>
//           <Route
//             path="/admin/interview-dashboard"
//             element={<InterviewDashboardComponent/>}
//           />
//           <Route
//             path="/admin/dashboard"
//             element={<AdminDashboardComponent/>}
//           />
//           <Route
//             path="/admin/applicants-dashboard"
//             element={<ApplicantDashboardComponent/>}
//           />
//           <Route
//             path="/admin/candidates-dashboard"
//             element={<CandidatesDashboardComponent/>}
//           />
//           <Route
//             path="/admin/customer-dashboard"
//             element={<CustomerDashboardComponent/>}
//           />
//           <Route
//             path="/admin/private-job"
//             element={<PrivateJobComponent/>}
//           />
//           <Route
//             path="/admin/council-job"
//             element={<CouncilJobComponent/>}
//           />
//           {/* <Route path='/dashboard/form4' element={NFormFourComponent} /> */}
//         </Routes>
//       </AdminLayout>
//     </Route>
//     <Route path="/client/:path?">
//       <CvLayout>
//         <ClientFormLayout>
//           <Routes>
//             <Route path="/client/form1" element={<ClientFormComponent/>} />
//             <Route
//               path="/client/summary"
//               element={<ClientSummaryComponent/>}
//             />
//             <Route
//               path="/client/complete"
//               element={<ClientCompleteComponent/>}
//             />
//           </Routes>
//         </ClientFormLayout>
//       </CvLayout>
//     </Route>
//     <Route path="/admins/:path?">
//       <CvLayout>
//         <CvRegistrationLayout>
//           <Routes>
//             <Route
//               path="/admins/summary"
//               element={<AdminSummaryComponent/>}
//             />
//           </Routes>
//         </CvRegistrationLayout>
//       </CvLayout>
//     </Route>
//     <Route path="/registration/:path?">
//       <CvLayout>
//         <CvRegistrationLayout>
//           <Routes>
//             <Route
//               path="/registration/cv-summary"
//               element={<CvSummaryComponent/>}
//             />
//             <Route
//               path="/registration/submit-cv"
//               element={<CvPageComponent/>}
//             />
//             <Route
//               path="/registration/cv-complete"
//               element={<CvCompleteComponent/>}
//             />
//           </Routes>
//         </CvRegistrationLayout>
//       </CvLayout>
//     </Route>

//     <Route>
//       <InnerPageLayout>
//         <Routes>
//           <Route path="/login" element={<LoginComponent/>} />
//           <Route
//             path="/clients/type-selection"
//             element={<ClientSelectionComponent/>}
//           />
//           <Route
//             path="/user/registration-selection"
//             element={<ResistrationSelectionComponent/>}
//           />
//           <Route
//             path="/forgot-password-email"
//             element={<ForgotComponent/>}
//           />
//           <Route path="/reset-password" element={<ResetComponent/>} />
//           <Route path="/pages/:id" element={<CmsComponent/>} />
//           <Route path="/about-us" element={<AboutUsComponent/>} />
//           <Route path="/find-jobs" element={<FindJobComponent/>} />
//           <Route
//             path="/schedule-interview"
//             element={<ScheduleInterviewComponent/>}
//           />
//           <Route
//             path="/job-details/:id"
//             element={<JobDetailsComponent/>}
//           />
//           <Route path="/job-post" element={<PostJobComponent/>} />
//           <Route
//             path="/user/registration"
//             element={<CommonRegistrationComponent/>}
//           />
//           <Route path="/registrations/individual/:path?">
//             <IRegistrationLayout>
//               <Routes>
//                 <Route
//                   path="/registrations/individual/form1"
//                   element={<IFormOneComponent/>}
//                 />
//                 <Route
//                   path="/registrations/individual/form2"
//                   element={<IFormTwoComponent/>}
//                 />
//                 <Route
//                   path="/registrations/individual/form3"
//                   element={<IFormThreeComponent/>}
//                 />
//               </Routes>
//             </IRegistrationLayout>
//           </Route>
//           <Route path="/registrations/council/:path?">
//             <CRegistrationLayout>
//               <Routes>
//                 <Route
//                   path="/registrations/council/form1"
//                   element={<CFormOneComponent/>}
//                 />
//                 <Route
//                   path="/registrations/council/form2"
//                   element={<CFormTwoComponent/>}
//                 />
//                 <Route
//                   path="/registrations/council/form3"
//                   element={<CFormThreeComponent/>}
//                 />
//               </Routes>
//             </CRegistrationLayout>
//           </Route>
//           {/* //#NFormFourComponent is not used (payment form) */}
//           <Route path="/registrations/:path?">
//             <NRegistrationLayout>
//               <Routes>
//                 <Route
//                   path="/registrations/form1"
//                   element={<NFormOneComponent/>}
//                 />
//                 <Route
//                   path="/registrations/form2"
//                   element={<NFormTwoComponent/>}
//                 />
//                 <Route
//                   path="/registrations/form3"
//                   element={<NFormThreeComponent/>}
//                 />
//                 <Route
//                   path="/registrations/form4"
//                   element={<AllSummaryComponent/>}
//                 />
//                 <Route
//                   path="/registrations/form5"
//                   element={<NFormFourComponent/>}
//                 />
//               </Routes>
//             </NRegistrationLayout>
//           </Route>
//         </Routes>
//       </InnerPageLayout>
//     </Route>
//   </Routes>
// </Router>
// </Suspense>
